import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import dayjs from 'dayjs'
const vuexLC = new VuexPersist({
  storage: window.localStorage
})
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    metaInfo: {},
    userInfo: {
      id: '',
      trueName: '匿名',
      mobile: '',
      userName: '',
      nickName: '',
      jifen: '',
      avatarUrl: '',
      email: ''
    },
    companyInfo: {
      currency: 'HKD',
      email: '',
      id: '',
      userName: '',
      linkSerial: '',
      mobile: '',
      trueName: '',
      type: ''
    },
    userType: 'B2C',
    token: {
      val: '',
      exp: 0
    },
    isLogin: false,
    currency: 'HKD',
    lang: 'zhCN'
  },
  mutations: {
    CHANGE_META_INFO (state, metaInfo) {
      state.metaInfo = metaInfo
    },
    setTureName (state, trueName) {
      state.userInfo.trueName = trueName
    },
    setMobile (state, mobile) {
      state.userInfo.mobile = mobile
    },
    setEmail (state, email) {
      state.userInfo.email = email
    },
    setUserInfo (state, userInfo) {
      if (!userInfo.trueName || userInfo.trueName === '') userInfo.trueName = userInfo.nickName
      if (!userInfo.trueName || userInfo.trueName === '') userInfo.trueName = '匿名'
      state.userInfo = userInfo
      state.isLogin = true
    },
    setCompanyInfo (state, companyInfo) {
      state.companyInfo = companyInfo
    },
    delUserInfo (state) {
      state.companyInfo = {
        currency: 'HKD',
        email: '',
        id: '',
        userName: '',
        linkSerial: '',
        mobile: '',
        trueName: '',
        type: ''
      }
      state.userInfo = {
        id: '',
        trueName: '匿名',
        userName: '',
        mobile: '',
        nickName: '',
        jifen: '',
        avatarUrl: '',
        email: ''
      }
      state.token = {
        val: '',
        exp: 0
      }
      state.isLogin = false
      state.userType = 'B2C'
    },
    setCurrency (state, currency) {
      state.currency = currency
    },
    setLang (state, lang) {
      state.lang = lang
    },
    setToken (state, token) {
      state.token = token
    },
    setUserType (state, type) {
      state.userType = type
    }
  },
  getters: {
    VcompanyInfo: state => state.companyInfo,
    VuserInfo: state => state.userInfo,
    VisLogin: state => state.isLogin,
    Vcurrency: state => state.currency,
    Vlang: state => state.lang,
    VuserType: state => state.userType,
    Vtoken: state => {
      if (dayjs().unix() + 60 >= state.token.exp) {
        store.commit('delUserInfo')
        return ''
      } else {
        return state.token.val
      }
    }
  },
  plugins: [
    vuexLC.plugin
  ]
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js